import React, { useContext } from 'react';
import GigCardListings from '@fiverr-private/gig_listings/src/entries/GigCardListings';
import ListViewListings from '@fiverr-private/gig_listings/src/entries/ListViewListings';
import { CollectionContext, AppContext } from '../../../store';
import { GIG_CARDS_LAZY_OFFSET, LIST_VIEW_CARDS_LAZY_OFFSET, LISTINGS_DESKTOP_SIZE } from './constants';

const DynamicGigListings = (props) => {
    const {
        listings,
        gigCardLazyLoadOffset = GIG_CARDS_LAZY_OFFSET,
        listViewLazyLoadOffset = LIST_VIEW_CARDS_LAZY_OFFSET,
        isVintageProTest,
        banner,
        bannerConfig
    } = props;

    const { collectProps } = useContext(CollectionContext);
    const { filter: { active: activeFilters }, inDiscountTest, inLogoDesignDiscountTest } = useContext(AppContext);
    const { showListViewCards } = listings;

    return (
        !showListViewCards ?
            <GigCardListings {...listings}
                collectProps={collectProps}
                lazyLoadOffset={gigCardLazyLoadOffset}
                size={LISTINGS_DESKTOP_SIZE}
                isVintageProTest={isVintageProTest}
                banner={banner}
                activeFilters={activeFilters}
                bannerConfig={bannerConfig}
                inDiscountTest={inDiscountTest}
                inLogoDesignDiscountTest={inLogoDesignDiscountTest}/>
            :
            <ListViewListings {...listings}
                collectProps={collectProps}
                lazyLoadOffset={listViewLazyLoadOffset}
                banner={banner}
                activeFilters={activeFilters}
                bannerConfig={bannerConfig}/>
    );
};

export default DynamicGigListings;
